import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { LoggerService } from './app/logger/logger.service';

// En producción solo salen advertencias y errores: los log.debug/info traen
// datos de pacientes y usuarios que no deben quedar en la consola.
if (environment.production) {
  LoggerService.enableProductionMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
